import { Injectable } from "@angular/core";
import { Socket } from "ngx-socket-io";
import { environment } from "src/environments/environment";
import { AuthService } from "../services/auth.service";

@Injectable()
export class DomHub extends Socket {
  constructor(authService: AuthService) {
    super({
      url: environment.dispatchUrl,
      options: {
         query: { token: authService.token},
         transports: [ 'websocket', 'polling' ]
        }
      });
  }
}
